<template>
	<div class="addfujian">
		<p v-for="(item,index) in attaArr"><span>{{item.description}}</span> <a :href="item.url" class="delete" :download='item.url' target="_blank">[下载]</a></p>
	</div>
</template>

<script>
	export default{
		name:'resstep',
		props:[
			'attaArr'
		]
	}
</script>

<style scoped="scoped">
.addfujian{padding: 10px 0;overflow: hidden;}
.addfujian p{
	background: url('../../../static/images/fj.png') no-repeat left center;
	padding-left: 20px;	
	cursor: pointer;
	margin-bottom: 10px;
	line-height: 30px;
	float: left;
	margin-right: 150px;
	
}
.addfujian p span{
	max-width: 200px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	display: inline-block;
	vertical-align: middle;	
}
.addfujian p.add{color: #00abfa;}
.addfujian p .delete{color: #00abfa;margin-left: 10px;text-decoration: none;}	
</style>


// WEBPACK FOOTER //
// src/components/attachment/index1.vue